<template>
	<ViewFeedItem class="view-user-favoriteplaces">
		<template v-slot:header>
			<ViewLayoutModuleHeader v-bind:title="userModel.getFirstName() + '\'s Favorites'">
				<RouterLink v-bind:to="{ name: 'PagePlaces' }" v-if="showViewAll && favoriteCollection.length">
					<strong>View All</strong>
				</RouterLink>
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyVenueList
				class="horizontal"
				v-bind:key="favoriteCollection.uniqueKey"
				v-bind:venueCollection="favoriteCollection"
				v-if="favoriteCollection.length"
				v-on:venue:select="Handle_OnSelectVenue"
			/>

			<section v-else>
				<ViewUiCalloutIcon v-bind:message="message" iconFilename="heart-fill.svg" />
			</section>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Factory from '@/App/Factory';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, event, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/User
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUserRecentCheckins extends ViewBase {
		/**
		 * @return string
		 */
		protected get message(): string {
			return this.userModel.getFirstName() + ' has not favorited<br />any places yet';
		}

		/**
		 * @return boolean
		 */
		@Prop({ default: true })
		public showViewAll!: boolean;

		/**
		 * @type ChalkySticks/Model/User
		 */
		@Prop({
			default: () => new ChalkySticks.Model.User(),
		})
		public userModel!: ChalkySticks.Model.User;

		/**
		 * @type ChalkySticks/Model/Venue
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.Venue.collection({
					limit: 32,
					qp: {
						reaction_from: '',
						reaction_type: ChalkySticks.Enum.ReactionType.Love,
					},
				}),
		})
		public favoriteCollection!: ChalkySticks.Collection.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-user-favoriteplaces {
		.venue-list.horizontal .venue-card {
			--chalky-venue-list-thumbnail-width: 85%;

			.utility-gallery {
				height: 45svh;
			}
		}
	}
</style>
